import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackShareLinkFontUpdated.meta';

export type UseTrackShareLinkFontUpdatedParams = {
  font: string;
  from_brand_context: boolean;
};

export const useTrackShareLinkFontUpdated = () => {
  const { track } = useAnalyticsUtilities();

  const trackShareLinkFontUpdated = useCallback(
    (params: UseTrackShareLinkFontUpdatedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackShareLinkFontUpdated };
};
